export const root = "r1263pg0";
export const brand1 = "bsdcwhm";
export const brand2 = "bqk3ogd";
export const consumeSpace = "cmsyswa";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");